var parseDate = require('i18n-parse-date');
var locales = {
    en_US: require('../locales/en_US'),
    da_DK: require('../locales/da_DK'),
    fr_FR: require('../locales/fr_FR'),
    de_DE: require('../locales/de_DE'),
    nl_NL: require('../locales/nl_NL'),
}
var i18nContext = require('i18n-context')('ember_date_field', locales);
var t = i18nContext.t;

module.exports = require('ember-text-field').extend({
    autocomplete: 'off',

    classNames: ['date-field'],

    sameDateString: function() {
        return t('same_date');
    }.property(),

    sameDate: null,

    showSelectorOnDownArrow: true,

    relative: false,

    init: function() {
        this._super();
        this.reformatInputValue(); //Trick to make sure that sameDate was set when formatting the inputValue
    },

    picker1Icon: 'calendar',

    manipulateValue: function(value) {
        if (typeof value === 'string') {
            value = moment(value, 'YYYY-MM-DD');
        }
        value = value || null;
        Ember.assert('Value `'+value+'` is a not a valid moment object or null.', value === null || moment.isMoment(value));
        return value;
    },

    formatInputValue: function(value) {
        if (Ember.isEmpty(value)) {
            return null;
        }
        if (this.get('relative')) {
            if (value.isSame(moment().subtract(1, 'day'), 'day')) {
                return t('yesterday');
            }
            if (value.isSame(moment(), 'day')) {
                return t('today');
            }
            if (value.isSame(moment().add(1, 'day'), 'day')) {
                return t('tomorrow');
            }
        }
        var sameDate = this.get('sameDate');
        if (sameDate && value.format('L') == sameDate.format('L')) {
            return this.get('sameDateString');
        }
        return value.format('L');
    },

    sameDateDidChange: function() {
        this.reformatInputValue();
    }.observes('sameDate'),

    unformatInputValue: function(inputValue) {
        return Ember.isEmpty(inputValue) ? null : parseDate(inputValue)
    },

    validateInputValue: function(inputValue) {
        if (!Em.isEmpty(inputValue) && this.get('sameDateString') != inputValue && !(this.get('relative') && [t('yesterday'), t('today'), t('tomorrow')].contains(inputValue))) {
            var value = parseDate(inputValue);
            if (!value) {
                throw new UserError(t('invalid_date'));
            }
        }
    },

    selector: null,

    didClickPicker1: function() {
        if (this.get('selector')) {
            this.hideSelector();
        } else {
            this.showSelector();
        }
        this.focus();
    },

    showSelector: function() {
        var self = this,
            selector = this.get('selector');
        if (!selector) {
            selector = this.container.lookup('component:date-selector');
            this.set('selector', selector);
            selector.set('value', this.get('value'));
            selector.set('keyEl', this.$());
            selector.one('select', function(date) {
                self.selectValue(date);
                self.hideSelector();
            });
            selector.one('willDestroyElement', function() {
                self.set('selector', null);
            });
            selector.show(this);
        }
    },

    hideSelector: function() {
        var selector = this.get('selector');
        if (selector) {
            selector.destroy();
        }
    },

    keyDown: function(e) {
        if (!this.get('selector')) {
            if (e.which == $.keyCode.DOWN && this.get('showSelectorOnDownArrow')) {
                e.preventDefault();
                this.showSelector();
            }
        }
    },

    selectValue: function(value) {
        this.set('value', value);
        Ember.run.schedule('sync', this, function() {
            this.sendAction('didSelect', value);
        });
    }
});

module.exports.locale = i18nContext.locale;

module.exports.lang = function() {
    console.warn('.lang() is deprecated. Use .locale() instead');
    return i18nContext.locale.apply(null, arguments);
};
